import React, { Component, PureComponent, useContext } from 'react';
import {NavLink, Link, Redirect, BrowserRouter as Router, Route, Switch} from 'react-router-dom'
// import {createBrowserHistory} from 'history'

import Headers from './Headers'
import './index.scss'
import './home.scss'
import AutoMenu from '../../react/AutoMenu'

import Order from './Order'
import Sorry from './Sorry'
import Form from './Form'
import Franchise from './Franchise'
import Catering from './Catering'
import FormFranchise from './FormFranchise'
import CateringForm from './CateringForm'
import {SiteNotice} from '../../Notices/SiteNotice'
import Press from './Press'
import GiftCards from './GiftCards'
import Promotion from './Promotion'
import Vote from './Vote'

import locationsInfo from './locations'
import {RootRouterContext} from '../../index.js'
import {ShopDataContext} from '../../Context/ShopData'
import BakeryVideo from './BakeryVideo'


import CartBar from './CartBar'

export const StickyTopBar = () => { return null }



export const locations = [
  {shopId: "pablitostacosburbank",  basePath:  "/burbank"},
  {shopId: "pablitostacosburbank",  basePath:  "/hamburguetzaburbank"},
  {shopId: "pablitostacosnoho",     basePath:     "/noho"},
  {shopId: "pablitostacosnoho",     basePath:     "/nohoPizza"},
  {shopId: "pablitostacosnoho",     basePath:     "/hamburguetza"},
  {shopId: "pablitosevent",     basePath:     "/night", cssGlobalPrefix: 'pablitostacosburbank'},
  {shopId: "pablitostacosstudio",   basePath:   "/studio", cssGlobalPrefix: 'pablitostacosburbank'},
  {shopId: "pablitostacosvictory",  basePath:  "/victory"},
  {shopId: "pablitostacosmoorpark", basePath: "/moorpark"},
  {shopId: "pablitostacosvannuys",  basePath:  "/vannuys", cssGlobalPrefix: 'pablitostacosburbank'},
  {shopId: "pablitostacosvannuys",  basePath:  "/vannuyshamburguetza", cssGlobalPrefix: 'pablitostacosburbank'},
  {shopId: "pablitostacosvannuys",  basePath:  "/vannuyschicken", cssGlobalPrefix: 'pablitostacosburbank'},
  {shopId: "pablitostacosdtla",  basePath:  "/dtla"},
  {shopId: "pablitostacosnorth",    basePath:  "/popup"},
  {shopId: "pablitostacosnorth",    basePath:  "/northhills"},
  {shopId: "pablitostacoscorona",    basePath:  "/corona", cssGlobalPrefix: 'pablitostacosburbank'},
  {shopId: "pablitostacosnorth",    basePath:  "/palmdale"},
  {shopId: "pablitosmarket",        basePath:  "/market", cssGlobalPrefix: 'pablitostacosburbank'},
  {shopId: "pablitostacosnorth",        basePath:  "/shermanoaks", cssGlobalPrefix: 'pablitostacosburbank'},
]

// function navigateToHome (e) {
//   e.preventDefault()
//   const rootHistory = createBrowserHistory()
//   rootHistory.push('/')
// }

export const pages = [
  // {path: "/", external: true,  label: "All Locations"},
  {path: "/menu", label: "Menu"},
  
  // {path: "/merch", label: "Merch", component: Merch},
  {path: "/press", label: "Press", component: Press, hideFromNav: true},
  {path: "/sorry", hideFromNav: true, component: Sorry},
  {path: "/reward", label: "-", hideFromNav: true, component: Promotion},
  {path: "/gift-cards/:status", hideFromNav: true, label: "Gift Cards", component: GiftCards },
  {path: "/gift-cards", label: "Gift Cards", component: GiftCards },
]

export const customOrderAppPaths = ["/menu", "/order", "/burbank/order"]


const BottomBar = function () {
  return(
    <div className="bottom-bar">
      
    </div>
  )
}

export function SiteNav ({shopId}) {
    const {rootHistory} = useContext(RootRouterContext)
    // console.log('rootrouter: ', rootRouter)

    return (
      <>
      <CartBar shopId={shopId}></CartBar>
    <nav className="pages-nav">
      <ul>
        <li><a className="page-link" href="/" onClick={(e) => {
          e.preventDefault()
          rootHistory.push('/')
        }}>All Locations</a></li>
        {pages
          .filter(({hideFromNav}) => !hideFromNav)
          .map(({path, label, external, onClick}) => (
          <li key={path}>
            {external ?
              <a       className="page-link" href={path}>{label}</a> :
              <NavLink className="page-link" exact to={path}>{label}</NavLink>}
          </li>
        ))}
      </ul>
    </nav>
  </>
  )
}




export function Header (props) {

  
    console.log('header', props)
    return (
      <div className="landing-page-wrapper">
        <div className="landing-page">

          <div className="text">
            <div className="hero-logo">
              <img src="https://d2abh92eaqfsaa.cloudfront.net/image/upload/q_82,w_400/v1551736184/danstuff/pablitos-tacos-cut.png" alt=""/>
            </div>

            



            {((props.shopId === 'pablitostacosstudio')
            // || (props.shopId === 'pablitostacosburbank')
            // || (props.shopId === 'pablitostacosnoho')
            // || (props.shopId === 'pablitostacosmoorpark')
            || (props.shopId === 'pablitostacosvictory'))
            &&
              <div>
                {/* <a href="https://pablitostacos.com"></a> */}
                <p>Moved to 11502 Ventura Boulevard</p>
                <p>View  <a href="https://pablitostacos.com/popup">Location Info</a></p>
              </div>

            }


            {
              // (props.shopId !== 'pablitostacosnoho') &&
              (props.shopId !== 'pablitostacosstudio')
            && (props.shopId !== 'pablitostacosvictory')
            // && (props.shopId === 'pablitostacosburbank')
            // && (props.shopId !== 'pablitostacosmoorpark')
            && <div className="info">
              {locationsInfo
                .filter((l) => l.id === props.shopId)
                .slice(0,1)
                .map(({label, address, phone, hours, special, phoneLink, className=""}) => (
                  <div className={"location"}>
                    <div className="content">
                      {address && <div className="address">
                        {address[0]} <br/>
                        {address[1]}
                      </div>}
                      {phone && <div className="phone">
                        <a
                          className="phone-link"
                          href={`tel:${phoneLink}`}>{phone}</a>
                      </div>}
                      {hours && <ul className="hours-of-operation">
                        {hours.map((hours) => {
                          return (<li key={hours.day}>
                            <span className="day">{hours.day}</span>
                            <span className="hours">{hours.hours}</span>
                          </li>)
                        })}
                      </ul>}
                    </div>
                  </div>
              ))}

              <div className="order-action">
                    <a href="#order" className="order-button">Order Pickup / Delivery</a>
                 
                  </div>


            </div>}


          </div>


        

        

        </div>
        {(true) &&
              <div style={{
                display: 'flex',
                padding: "1em 0.5em",
                justifyContent: 'center',
                alignItems: "center",
                background: "black",
                color: "white"
                }}>
                {/* <img 
                style={{
                  display: 'block',
                  width: "100%",
                  maxWidth: "250px"
                }}
                src="https://afag.imgix.net/pablitos-tacos-burbank/fire.png?w=500&auto=format" alt="" /> */}


                <div style={{maxWidth: "700px", paddingLeft: "1em"}} className="specials">
                  {/* <h3><span className="specials-text">Enjoy 10% Cashback by Ordering Direct!</span></h3> */}
                  {/* <h3 style={{textAlign: "left"}}>Help Us Buy School Supplies For Poor Areas of Lima, Peru</h3> */}
                  {/* <p>Donations Matched by Pablito's Tacos!!! 🌮🇵🇪 <a style={{color: "red"}} href="https://www.gofundme.com/f/help-kids-from-poor-village-with-school-supplies?attribution_id=sl:40c5a78c-ce37-439a-88d1-661a53e8ad1e&utm_campaign=natman_sharesheet_dash&utm_medium=customer&utm_source=copy_link">Donate on GoFundMe now!</a></p> */}
                  {/* <p><a href="https://www.instagram.com/p/CtrQBUcLIg6/">image from @dadjack</a></p> */}
                </div>
              </div>
            }

       
       

        <h2 id="order" style={{visibility: 'hidden', height: "0px", margin: "0", padding: "0"}}>Order Online</h2>


                      

        {(props.basePath === '/nohoPizza') && 
          
          
            <div className="ordering-menu">

      

              <AutoMenu
              altStyleA
              subMenuFilter={subMenuFilter}
              tagsToShow={['pizza']}></AutoMenu>
            <AutoMenu
            altStyleA
              subMenuFilter={(subMenu) => {
                const isShownNormally = subMenuFilter(subMenu)
                const tag = subMenu.tag || ''
            
                const isHidden = tag.indexOf('hidden') !== -1
                const isPizza = tag.indexOf('pizza') !== -1
                const isBreakfast = tag.indexOf('noho-breakfast') !== -1
            
                if (isPizza ) {
                  return false
                }
                return isShownNormally
              }}
              ></AutoMenu>
            </div>
        }


        {(props.basePath === '/hamburguetza') && 
          
          
          <div className="ordering-menu">

    

            <AutoMenu
            altStyleA
            subMenuFilter={subMenuFilter}
            tagsToShow={['hamburguetza']}></AutoMenu>
          {/* <AutoMenu
            subMenuFilter={(subMenu) => {
              const isShownNormally = subMenuFilter(subMenu)
              const tag = subMenu.tag || ''
              const isBreakfast = tag.indexOf('noho-breakfast') !== -1

              const isHidden = tag.indexOf('hidden') !== -1
              const isPizza = tag.indexOf('hamburguetza') !== -1
          
              if (isPizza) {
                return false
              }
              return isShownNormally
            }}
            ></AutoMenu> */}
          </div>
      }

      {(props.basePath === '/hamburguetzaburbank') && 
          
          
          <div className="ordering-menu">

    

            <AutoMenu
            altStyleA
            subMenuFilter={subMenuFilter}
            tagsToShow={['hamburguetza']}></AutoMenu>
          {/* <AutoMenu
            subMenuFilter={(subMenu) => {
              const isShownNormally = subMenuFilter(subMenu)
              const tag = subMenu.tag || ''
              const isBreakfast = tag.indexOf('noho-breakfast') !== -1

              const isHidden = tag.indexOf('hidden') !== -1
              const isPizza = tag.indexOf('hamburguetza') !== -1
          
              if (isPizza) {
                return false
              }
              return isShownNormally
            }}
            ></AutoMenu> */}
          </div>
      }

      {(props.basePath === '/vannuyschicken') && 
          
          
          <div className="ordering-menu">

            <AutoMenu
            altStyleA
            subMenuFilter={subMenuFilter}
            tagsToShow={['pab-chicken']}></AutoMenu>
         
          </div>
      }

       {(props.basePath === '/vannuyshamburguetza') && 
          
          
          <div className="ordering-menu">

            <AutoMenu
            altStyleA
            subMenuFilter={subMenuFilter}
            tagsToShow={['hamburguetza']}></AutoMenu>
         
          </div>
      }

     


        {(props.basePath !== '/nohoPizza') && (props.basePath !== '/hamburguetzaburbank') && (props.basePath !== '/vannuyschicken') && 
        (props.basePath !== '/vannuyshamburguetza') &&
          
          <div className="ordering-menu">

      {/* {(props.basePath === '/noho') &&
      <div 
      style={{
        background: 'black',
        paddingBottom: "3em",
        textAlign: 'center',
        lineHeight: "1.3em",
        fontWeight: 800,
      }}
      className="promo">
        <p

        >🆕 Check out the new <br/>Hamburguetza <br/>Angus Burger & Sandwich<br/>sections at the bottom</p>
      </div>
      } */}
            
          

            <AutoMenu 
            altStyleA
            subMenuFilter={subMenuFilter}
            ></AutoMenu>

          </div>
        }


        

        



      </div>
    );
  
}

const mainNav = [
  {path: '/', label: "Home"},
  // {path: '/gift-cards', label: "Gift Cards"},
  {path: '/about-us', label: "About Us"},
  {path: 'https://pablitostacosfranchise.com', external: true, label: "Franchise"},
  {path: '/catering', label: "Catering"},
  // {path: "/vote", label: "Vote", component: Vote},

]

export function MultilocationHome () {
  
  const logoImage = `https://afag.imgix.net/pablitos-tacos-burbank/california-burrito-new.png?h=200`
  const circleImage = `https://afag.imgix.net/pablitos-tacos-burbank/logo.png?w=200`
  // const {menu, settings} = useContext(ShopDataContext)
  // console.log('>>>  settings', settings)
  return (
    <div className="site-content pablitostacos">

<Headers></Headers>

      <div className="main-page cart-wrapper">

        <div className="cart minimized">
          <div className="home-link-wrapper">
            <Link to="/" className="home-link">
              <img
                className="nav-bar-logo"
                // style={{ height: "50px"}}
                  src={logoImage} alt={"Pablitos Tacos"}/>
            </Link>

          </div>

          </div>

        </div>
        <nav className="main pages-nav">
          <ul>
            {mainNav
              .filter(({hideFromNav}) => !hideFromNav)
              .map(({path, label, external, onClick}) => (
              <li key={path}>
                {external ?
                  <a       className="page-link" href={path}>{label}</a> :
                  <NavLink className="page-link" exact to={path}>{label}</NavLink>}
              </li>
            ))}
          </ul>
        </nav>
      {/* <div className="home-nav">
        <div className="logo">
          <img src={circleImage} alt=""/>
        </div>
        <div className="nav-items">
          <NavLink to="/locations">Order</NavLink>
          <NavLink to="/press">Press</NavLink>
        </div>
      </div> */}

      <Switch>
        <Route path="/about-us" component={Press} />
        <Route path="/vote" component={Vote} />
        {/* <Route path="/franchise" component={Franchise} /> */}
        <Route path="/catering" component={Catering} />


        <LandingPage></LandingPage>
      </Switch>

      <FormFranchise hide={true}></FormFranchise>
      <CateringForm hide={true}></CateringForm>
    </div>
  );
}


function LandingPage () {
  return(


      <div className="landing-page-wrapper">
        <Headers></Headers>
{/* 
        <SiteNotice
          orderLink="/#locations"
          noDrinks={true}
           forceShow={"All Day Breakfast @ Burbank!"}></SiteNotice> */}


        {/* <div className="franchise">
          <a href="https://pablitostacosfranchise.com">
            <div
            style={{
              background: `url(https://afag.imgix.net/pablitos-tacos-burbank/franchise.heic?w=2000&auto=format) no-repeat`,
              backgroundColor: "black",
              backgroundSize: "contain",
              backgroundPosition: "center",
              height: "200px"
            }}
             className="franchise-bg">
              
            </div>
          </a>
        </div> */}

        <BakeryVideo></BakeryVideo>

        {/* <div className="multi-home-special">
          <h2 className="title">Taco Tuesday Special!</h2>

          <p>
            <Link to="/burbank">Burbank:</Link> 50% off taqcos/quesotacos/vampiros/mulitas, $1.99 birria taquitos,$5.99 choriqueso and chip or guac
          </p>
          <p>
            <Link to="/vannuys">Van Nuys:</Link> $9.99 1/4 rotiserrie chicken fries and salad, $1 tacos, $9.99 pollo a la brasa bowl-rito, $1.99  taquitos
          </p>
          <p>
            <Link to="/burbank">Noho:</Link> $5 burgers, $1 tacos
          </p>
        </div> */}

        <div className="section">
          {/* <header className="locations-header">
            <div className="site-logo">
              <img src="https://d2abh92eaqfsaa.cloudfront.net/image/upload/q_82,w_400/v1551736184/danstuff/pablitos-tacos-cut.png?width=150" alt=""/>
            </div>



            <div className="header">

         
            </div>

       
          </header> */}

          {/* <section className="featured">
            <article className="product">
              <div className="photo"></div>
              <div className="details">
                <h3></h3>
              </div>
            </article>
          </section> */}



          <header className="location-header">
            <h2 id="locations">4 Locations!</h2>
          
          </header>
          <div className="locations">


            {locationsInfo.map(({concepts, cashback, id, tax, type, external, link, disabled, openingDate, special, label, buttonLabel, address, phone, hours, phoneLink, className=""}) => (
              <div className={"grid-item location " + className}>
                <div className="content">
                  <h3 className="title">{label}</h3>
                  {type && <div className="type">{type}</div>}
                 

   

                  {special && <div className="specials">
                    <span className="specials-text">{special}</span>
                  </div>}
                  {cashback && <div className="specials">
                    <span className="specials-text">{cashback}% cashback</span>
                  </div>}


                  {tax && <div className="tax">
                    <span className="specials-text">{tax}</span>
                  </div>}



                  {address && <div className="address">
                    {address[0]} <br/>
                    {address[1]}
                  </div>}
                  {phone && <div className="phone">
                    <a
                      className="phone-link"
                      href={`tel:${phoneLink}`}>{phone}</a>
                  </div>}

                  {hours && <ul className="hours-of-operation">
                    {hours.map((hours) => {
                      return (<li key={hours.day}>
                        <span className="day">{hours.day}</span>
                        <span className="hours">{hours.hours}</span>
                      </li>)
                    })}
                  </ul>}


                  {concepts ?
                    <div className="concepts">
                    <p className="concept-description">at this location:</p>
                      {concepts.map(({link, label: conceptLabel}) => {
                        return (
                          <div key={link}>
                            <h4 className="concept-header">
                              <span className="location-label">{label}</span> {conceptLabel}
                            </h4>
                            <div className="order-actions">
                              {disabled ?
                                <Link to="#" className="order-button disabled">{openingDate}</Link> :
                                external ? 
                                <a className="order-button" href="https://pablitosworld.com">{"Visit Site"}</a>
                                :
                                <Link to={link} className="order-button">{buttonLabel || "Order Pickup/Delivery"}</Link>
                              }
                            </div>
                          </div>
                        );
                      })}
                    </div>

                  : <div className="order-actions">
                    {disabled ?
                      <Link to="#" className="order-button disabled">{openingDate}</Link> :
                      external ? 
                      <a className="order-button" href="https://pablitosworld.com">{"Visit Site"}</a>
                      :
                      <Link to={link} className="order-button">{buttonLabel || "Order Pickup/Delivery"}</Link>
                    }
                  </div>}
                </div>
              </div>
            ))}


<Form></Form>
          </div>

       
{/*
          <div
            style={{
              maxWidth: "800px",
              margin: "0 auto"
            }}
             className="event">
             <div
               style={{
                 margin: "1em 0.5em"
               }}
               className="header">
               <h2
                 >Live-Stream Event</h2>
                 <h3
                   style={{
                     fontSize: "1.3em",
                     padding: "0"
                   }}
                   >Signed Poster with Delivery Over $40<br/>(Burbank Location Only)</h3>
                 <h3
                   style={{
                     fontSize: "1.3em",
                            padding: "0",
                            color: "red"
                   }}
                   >CONTACT-FREE!</h3>

                   <p>Instagram <a href="https://www.instagram.com/pablitostacos/?hl=en">@pablitostacos</a> </p>
                   <p>Facebook <a href="https://www.facebook.com/pablitostacos818/">@pablitostacos818</a></p>

                  <h3><Link
                    style={{
                      fontSize: "1.3em",
                             padding: "0",
                             color: "red"
                    }}
                     to="/burbank/merch">Buy Merch<br/>Support Local Artists</Link></h3>
             </div>
            <img
              style={{
                width: "100%"
              }}
              src="https://afag.imgix.net/pablitos-tacos-burbank/live-event.jpg?w=1800&auto=format" alt=""/>
          </div> */}


          {/* <div className="old-locations">
            <h2>Other Locations</h2>
            <p><strong>Studio City,</strong> <strong>Oyster House</strong> &<strong> Western Tire</strong> locations are closed, please choose a location above.</p>
          </div> */}


        </div>
      </div>

  )
}

export class OrderingHeader extends PureComponent {
  render() {
    return (
      <div className="ordering-header-wrapper">
        {/* <div className="ordering-header">

          <div
            className="text"
             >
            <h2>Pablito's Rewards</h2>
            <p>5% Cashback on togo and delivery orders.</p>
          </div>
        </div> */}
      </div>
    );
  }
}


export function subMenuFilter (subMenu) {
  const tag = subMenu.tag || ''
  const now = new Date()
  const day = now.getDay() // Sunday - Saturday : 0 - 6
  const hours = now.getHours() //0 to 23
  const minutes = now.getMinutes() // 0 to 59
  const isWeekday = [1,2,3,4,5].indexOf(day) !== -1
  const isAllDayBreakfastMenu = tag.indexOf('breakfast') !== -1
  const isHidden = tag.indexOf('hidden') !== -1
  if (tag.indexOf('tuesday-thursdays') !== -1) {
    // thursday promo category
    if ((day === 2) || (day === 4)) {
      return true
    } else {
      return false
    }
  }
  if (tag.indexOf('thursdays-only') !== -1) {
    // thursday promo category
    if (day === 4) {
      return true
    } else {
      return false
    }
  }
  if (tag.indexOf('tuesday-only') !== -1) {
    // thursday promo category
    if (day === 2) {
      return true
    } else {
      return false
    }
  }
  if (tag.indexOf('noho-breakfast') !== -1) {
    if ((day === 1) || (day === 2)) {
      if ((hours > 0) && (hours < 16)) {
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  }
  if (tag.indexOf('noho-dinner') !== -1) {
    return true
    // thursday promo category
    // if ((day === 1) || (day === 2)) {
    //   if ((hours > 16)) {
    //     return true
    //   } else {
    //     return false
    //   }
    // } else {
    //   return true
    // }
  }

  if (tag.indexOf('promo-wing-it-wed') !== -1) {
    // wednesday promo category
    if (day === 3) {
      return true
    } else {
      return false
    }
  }

  if (isHidden) {
    return false
  }

  if (isAllDayBreakfastMenu && isWeekday) {
    return false
  }

  return true
}

const foodImages = [
  {
    url: "https://afag.imgix.net/pablitos-tacos-burbank/logo.jpg"
  },
  {
    url: "https://afag.imgix.net/pablitos-tacos-burbank/tacos-5.jpg"
  },
  {
    url: "https://afag.imgix.net/pablitos-tacos-burbank/tacos-2.jpg"
  },
  {
    url: "https://afag.imgix.net/pablitos-tacos-burbank/tacos-3.jpg"
  },
  {
    url: "https://afag.imgix.net/pablitos-tacos-burbank/tacos-4.jpg"
  },
]
